<template>
  <div
    class="field-wrapper field-wrapper--phone"
    :class="[field.cssClass, {'visually-hidden': field.visibility === 'hidden'}, 'field-wrapper--' + field.size]"
  >
    <div class="field-group field-group--block">
      <label
        class="label"
        :for="'input_' + formId + '_' + field.id"
      >
        {{ field.label }}<sup v-if="field.isRequired">*</sup>
      </label>

      <template v-if="field.inputMaskValue">
        <input
          :id="'input_' + formId + '_' + field.id"
          v-model="text"
          @focus="inputFocus"
          @blur="inputBlur"
          v-mask="'+41(#)## ### ## ##'"
          :name="'input_' + field.id"
          type="text"
        >
      </template>
      <template v-else>
        <input
          :id="'input_' + formId + '_' + field.id"
          v-model="text"
          @focus="inputFocus"
          @blur="inputBlur"
          v-mask="'+41(#)## ### ## ##'"
          :name="'input_' + field.id"
          type="text"
        >
      </template>

    </div>

    <slot name="description"></slot>
  </div>
</template>

<script>
import store from '../store';
import VFieldMixins from './VFieldMixins.vue';
import {mask} from 'vue-the-mask';
export default {
  store,
  name: "VFieldPhone",
  mixins: [VFieldMixins],
  data () {
    return {
      text: ''
    }
  },

  directives: {mask},

  methods: {
    /*onAccept (e) {
      const maskRef = e.detail;
      this.text = maskRef.value;
      //console.log('accept', maskRef.value);
      this.isPhoneComplete = false
    },
    onComplete (e) {
      const maskRef = e.detail;
      //console.log('complete', maskRef.unmaskedValue);
      this.isPhoneComplete = true
    },*/

    inputBlur (event) {
      event.target.parentNode.classList.remove('field-group--block-focus')

      if (!event.target.value) {
        event.target.parentNode.classList.remove('field-group--block-animated')
      }

      /*if (event.target.value.length === 0) {
        this.isPhoneComplete = true
      }

      store.commit('UPDATE_PHONE_IS_CORRECT', this.isPhoneComplete);*/
    },
  },
  props: {
    formId: Number,
    field: Object,
    fieldKey: Number
  },
  watch: {
    text: {
      immediate: true,
      deep: false,
      handler (newValue) {

       /* if (newValue.length === 0) {
          this.isPhoneComplete = true
        }

        store.commit('UPDATE_PHONE_IS_CORRECT', this.isPhoneComplete);*/

        store.commit(
            'UPDATE_USER_FORM_DATA' ,
            {'key': this.field.id, 'value': newValue})
      }
    }
  }
}
</script>
